
import CustomerDocumentMangement from "./component";
export default CustomerDocumentMangement;
